import { Fetch, FetchOptions } from '@/lib/fetch';
import { PaginationOf } from '@/types/pagination';
import {
  UserCreateDto,
  UserCreateEmailDto,
  UserDto,
  UserPowerUpdateDto,
  UserStatisticResultDto,
  UserTagUpdateDto,
  UserV3Dto,
} from '@wanjia/panama-sdk';
export const sysOpsUserService = {
  /**
   * 编辑用户-/api/sysOps/user/verify/{id}/v1
   **/
  async sysOpsVerifyUserPowers<T = void>(id: string, options?: FetchOptions): Promise<T> {
    return Fetch.put(`/api/sysOps/user/verify/${id}/v1`, {
      ...options,
    });
  },
  /**
   * 编辑用户-/api/sysOps/user/system/bySystem/v1
   **/
  async sysOpsCreateUser<T = UserDto>(data: UserCreateDto, options?: FetchOptions): Promise<T> {
    return Fetch.post(`/api/sysOps/user/system/bySystem/v1`, {
      data,
      ...options,
    });
  },
  /**
   * 编辑用户-/api/sysOps/user/{id}/tags/v1
   **/
  async sysOpsUpdateUserTags<T = object>(id: string, data: UserTagUpdateDto, options?: FetchOptions): Promise<T> {
    return Fetch.put(`/api/sysOps/user/${id}/tags/v1`, {
      data,
      ...options,
    });
  },
  /**
   * 根据邮箱查看用户信息-/api/sysOps/user/name/v1
   **/
  async sysOpsFindUsername<T = UserDto>(
    query?: {
      id?: string;
      username?: string;
      email?: string;
      mobile?: string;
    },
    options?: FetchOptions,
  ): Promise<T> {
    return Fetch.get(`/api/sysOps/user/name/v1`, {
      query,
      ...options,
    });
  },
  /**
   * 运营查看用户列表-/api/sysOps/users/v1
   **/
  async sysOpsFindUsers<T = PaginationOf<UserDto>>(
    query?: {
      type?: number;
      status?: string;
      userId?: string;
      idList?: string[];
      referrer?: string;
      tag?: string;
      channelCodes?: string[];
      createTimes?: number[];
      lastLoginTimes?: number[];
      lastCreateOrderTimes?: number[];
      hasEmail?: boolean;
      hasEmailOrMobile?: boolean;
      tags?: string[];
      excludeTags?: string[];
      companyTags?: string[];
      excludeCompanyTags?: string[];
      resourceTypes?: string[];
      country?: string;
      businessType?: string;
      userResourceCompanyTypes?: string[];
      userResourceCompanyName?: string;
      companyName?: string;
      userResourceBusinessType?: string;
      userResourceResourceTypes?: string[];
      userResourceCountry?: string;
      industryType?: string;
      companyTypes?: string[];
      useAI?: boolean;
      current?: number;
      pageSize?: number;
      keyword?: string;
      order?: string;
      sort?: string;
    },
    options?: FetchOptions,
  ): Promise<T> {
    return Fetch.get(`/api/sysOps/users/v1`, {
      query,
      ...options,
    });
  },
  /**
   * 运营查看用户详情-/api/sysOps/user/{id}/v1
   **/
  async sysOpsFindUser<T = UserV3Dto>(id: string, options?: FetchOptions): Promise<T> {
    return Fetch.get(`/api/sysOps/user/${id}/v1`, {
      ...options,
    });
  },
  /**
   * 编辑用户权限-/api/sysOps/user/powers/{id}/v1
   **/
  async sysOpsUpdateUserPowers<T = void>(id: string, data: UserPowerUpdateDto, options?: FetchOptions): Promise<T> {
    return Fetch.put(`/api/sysOps/user/powers/${id}/v1`, {
      data,
      ...options,
    });
  },
  /**
   * 编辑用户-/api/sysOps/user/AgainSendMail
   **/
  async sysOpsSendMail<T = void>(data: UserCreateEmailDto, options?: FetchOptions): Promise<T> {
    return Fetch.post(`/api/sysOps/user/AgainSendMail`, {
      data,
      ...options,
    });
  },
  /**
   * 营销资源-/api/sysOps/user/statistic/count/v1
   **/
  async sysOpsStatisticUserCount<T = UserStatisticResultDto>(
    query?: {
      userId?: string;
      timeRange?: number[];
      hasEmailOrMobile?: boolean;
    },
    options?: FetchOptions,
  ): Promise<T> {
    return Fetch.get(`/api/sysOps/user/statistic/count/v1`, {
      query,
      ...options,
    });
  },
  /**
   * 营销资源-/api/sysOps/user/statistic/visit/v1
   **/
  async sysOpsStatisticUserVisitCount<T = UserStatisticResultDto>(
    query?: {
      userId?: string;
      timeRange?: number[];
      hasEmailOrMobile?: boolean;
    },
    options?: FetchOptions,
  ): Promise<T> {
    return Fetch.get(`/api/sysOps/user/statistic/visit/v1`, {
      query,
      ...options,
    });
  },
};
